import 'react-phone-number-input/style.css';
import { Checkbox, Dropdown, FieldBox, Input } from '@swordhealth/ui-corporate';
import en from 'react-phone-number-input/locale/en';
import FileUpload from '@/app/components/core/forms/input/FileUpload';
import PhoneInput from 'react-phone-number-input';
import pt from 'react-phone-number-input/locale/pt';
import styled, { css } from 'styled-components';

const Field = ({
  name,
  label,
  type,
  placeholder,
  helperMessage,
  options,
  formik,
  locale,
  ...rest
}) => {
  switch (type) {
    case 'checkbox':
      return (
        <Checkbox
          name={name}
          label={label}
          onChange={(value) => formik.setFieldValue(name, value)}
          defaultChecked={formik.values[name]}
          value={formik.values[name]}
          helperMessage={helperMessage}
          errorMessage={formik.touched[name] && formik.errors[name]}
          className="checkbox-consent"
          variant={'minimal'}
          theme={'neutral'}
          {...rest}
        />
      );
    case 'dropdown':
      return (
        <Dropdown
          name={name}
          label={label}
          placeholder={placeholder}
          options={options}
          value={formik.values[name]}
          onChange={(value) => formik.setFieldValue(name, value)}
          helperMessage={helperMessage}
          errorMessage={formik.touched[name] && formik.errors[name]}
          {...rest}
        />
      );
    case 'file':
      return (
        <FileUpload
          name={name}
          label={label}
          placeholder={placeholder}
          value={formik.values[name]}
          minFiles={1}
          maxFiles={1}
          maxSize={5}
          multiple={false}
          formik={formik}
          helperMessage={helperMessage}
          errorMessage={formik.errors[name]}
          {...rest}
        />
      );
    case 'date':
      return (
        <StyledInput
          name={name}
          required
          label={label}
          placeholder={placeholder}
          data-placeholder={placeholder}
          value={formik.values[name]}
          type={type}
          onChange={(value) => formik.setFieldValue(name, value)}
          helperMessage={helperMessage}
          errorMessage={formik.touched[name] && formik.errors[name]}
          $hasValue={formik.values[name]}
          {...rest}
        />
      );
    case 'tel':
      return (
        <FieldBox
          required
          label={label}
          placeholder={placeholder}
          value={formik.values[name]}
          type={type}
          onChange={(value) => formik.setFieldValue(name, value)}
          helperMessage={helperMessage}
          errorMessage={formik.touched[name] && formik.errors[name]}
          {...rest}
        >
          <StyledPhoneInput
            name={name}
            labels={locale === 'pt' ? pt : en}
            international={false}
            defaultCountry="PT"
            value={formik.values[name]}
            onChange={(value) => formik.setFieldValue(name, value)}
          />
        </FieldBox>
      );
    default:
      return (
        <Input
          name={name}
          required
          label={label}
          placeholder={placeholder}
          value={formik.values[name]}
          type={type}
          onChange={(value) => formik.setFieldValue(name, value)}
          helperMessage={helperMessage}
          errorMessage={formik.touched[name] && formik.errors[name]}
          {...rest}
        />
      );
  }
};

export default Field;

const StyledInput = styled(Input)`
  input {
    height: 30px;
    ${(props) =>
      props.$hasValue &&
      css`
        color: ${(props) => props.theme.colors.grey.dark} !important;
      `};

    /* Hides browser's native placeholder */
    &::-webkit-datetime-edit {
      opacity: 0 !important;
    }

    &::-webkit-datetime-edit-text {
      opacity: 1 !important;
    }

    /* Makes it visible again on focus and when there's a valid date */
    &:focus::-webkit-datetime-edit {
      opacity: 1 !important;
    }

    &:valid::-webkit-datetime-edit {
      opacity: 1 !important;
    }

    /* Fake placeholder */
    &::before {
      content: attr(data-placeholder);
      color: ${(props) => props.theme.colors.grey.default};
      position: absolute;
    }
    &:focus::before {
      content: '';
    }
    &:valid::before {
      content: '';
    }
  }

  @media (max-width: 1279px) {
    input {
      height: 30px;

      ${(props) =>
        props.$hasValue &&
        css`
          width: fit-content;
        `};
    }
  }
`;

const StyledPhoneInput = styled(PhoneInput)`
  input {
    border: none;
  }
`;
